import { render, staticRenderFns } from "./grupoencargos.vue?vue&type=template&id=ca52ba1a&"
import script from "./grupoencargos.vue?vue&type=script&lang=js&"
export * from "./grupoencargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports